<template>
  <div class="ai-loader">
    <svg class="ai-loader__circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10" />
    </svg>
  </div>
</template>

<style scoped lang="scss" src="./AiCircleLoader.scss" />
